export enum Type {
  PREMIUM = 'premium',
  REUSABLE = 'reusable',
  NEW = 'new',
}

export enum Position {
  RIGHT = 'right',
  LEFT = 'left',
}
